export default {
  INICIO: 'inicio',
  ESTATISTICA: 'estatistica',
  PEDIDOS: 'pedidos',
  PEDIDO_STATUS: 'pedidoStatus',
  CARRINHO_ABANDONADO: 'carrinhoAbandonado',
  BALCONISTA: 'balconista',
  TIPO_CLIENTE: 'tipoCliente',
  SELECIONAR_PRODUTO: 'selecionarProduto',
  PRODUTO_SELECIONADO: 'produtoSelecionado',
  CRIAR_PRODUTO: 'criarProduto',
  SUGERIR_PRODUTO: 'sugerirProduto',
  MEIO_PAGAMENTO: 'meioPagamento',
  CUSTOMIZACAO_EMPRESA: 'customizacaoEmpresa',
  CUSTOMIZACAO_COR: 'customizacaoCor',
  CUSTOMIZACAO_BANNER: 'customizacaoBanner',
  CUSTOMIZACAO_HOME: 'customizacaoHome',
  CUSTOMIZACAO_SOCIAL: 'customizacaoSocial',
  FRETE: 'frete',
  NOTIFICACAO: 'notificacao',
  SOLICITACAO_PRO: 'solicitacaoProfissional',
  PROMOCOES_DIGITAIS: 'promocoesDigitais',
  PIXEL_FACEBOOK: 'pixelFacebook',
  FERRAMENTAS_ANALISE: 'ferramentasAnalise',
  SORTEIO: 'sorteioBalconista',
  RELATORIOFACEBOOKADS: 'relatorioFacebookAds',
  RELATORIOGOOGLEANALYTICS: 'relatorioGoogleAnalytics',
  RELATORIOQTDCLICKSWHATSAPP: 'relatorioQtdClicksWhatsApp',
  RELATORIOQTDCLICKSCONTATOS: 'relatorioQtdClicksContatos',
  INTEGRATIONMARKETPLACES: 'integrationMarketplaces',
  INTEGRATIONERP: 'integrationErp',
  INTEGRATIONTINY: 'integrationTiny',
  INTEGRATIONGOOGLESHOPPING: 'integrationGoogleShopping',
  VER_APP: 'verApp',
  ORCAMENTO_WHATSAPP: 'orcamentoWhatsapp',
  ORCAMENTOS: 'orcamentos',
  CLIENTES_INFO: 'clientesInfo',
  CADASTRAR_PRODUTO: 'cadastrarProduto',
  SERVICOS: 'servicos',
  AGUARDANDO_PRODUTOS: 'aguardandoProdutos',
  EDITAR_CATEGORIA: 'editarCategoria',
  GRADE_PRODUTO: 'gradeProduto',
  PRODUTOS_COMPRADOS: 'produtosComprados',
  PRODUTOS_BUSCADOS: 'produtosBuscados',
  IMPULSIONAR_PRODUTOS: 'impulsionarProdutos',
  FUNCIONAMENTO: 'funcionamento',
  PANFLETOS: 'panfletos',
  DESTAQUES: 'destaques',
  MEUS_LINKS: 'meusLinks',
  TERMOS_CONDICOES: 'termosCondicoes',
  PRIVACIDADE: 'privacidade',
  POLITICA_DEVOLUCAO: 'politicaDevolucao',
  NOTIFICACAO_APP: 'notificacaoApp',
  NOTIFICACAO_WHATSAPP: 'notificacaoWhatsapp',
  AGENTE_IA: 'agenteIa',
  ANTIFRAUDE: 'antifraude',
};
